/* eslint-disable import/prefer-default-export */

function formatAsRupees(amount, is_paise = true) {
  if (!amount) return "NaN"
  if (is_paise) amount /= 100
  return `${new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumSignificantDigits: 1,
  }).format(Math.ceil(amount))}/-`
}

export { formatAsRupees }
